// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__BygZ-","buttons":"SendReceipts_buttons__2m9mv","email":"SendReceipts_email__1_a9M","bookApptTitle":"SendReceipts_bookApptTitle__f2KkF"};